export enum ETypZavislosti {
    A = 'A',
    N = 'N',
    O = 'O'
}
